<template>
  <a-layout id="main-layout">
    <a-layout-header class="header">
      <div class="logo" >
        <img src="../assets/logo.png"/>
      </div>
      <a-menu class="nav" theme="dark" mode="horizontal" :default-selected-keys="['1']" :style="{ lineHeight: '64px' }">
        <a-menu-item key="1">物业管理</a-menu-item>
      </a-menu>
      <div class="user-control">
        <a-dropdown class="user-button" :placement="'bottomRight'">
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            <span style="padding-right: 8px;color: #CDCDCD">{{userName}}</span>
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a href="javascript:;">个人主页</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;">修改密码</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" @click="logout">退出登录</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>

    </a-layout-header>
    <a-layout style="display: flex;flex-direction: row;">
      <div class="main-sidebar">
        <a-button type="primary" @click="changeMenuCollapsed" class="collapseButton">
          <a-icon :type="menuCollapsed ? 'menu-unfold' : 'menu-fold'" />
        </a-button>
        <a-menu class="main-sidebar-menu" theme="dark" :inline-collapsed="menuCollapsed" mode="inline" :default-selected-keys="['welcome']" @click="menuClick">
          <a-menu-item key="welcome" style="margin-top: 0;" :title="'欢迎页'">
            <router-link :to="{path:'/'}"></router-link>
            <a-icon type="dashboard" />
            <span>欢迎页</span>
          </a-menu-item>
          <a-sub-menu key="co">
            <span slot="title"><a-icon type="cloud-server" /><span>物业公司管理</span></span>
            <a-menu-item key="coManage" :title="'公司列表'"><router-link :to="'/estate-company'">公司列表</router-link></a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="func">
            <span slot="title"><a-icon type="windows" /><span>功能管理</span></span>
            <a-menu-item key="funcManage" :title="'PC功能列表'"><router-link :to="'/func/list'">PC功能列表</router-link></a-menu-item>
            <a-menu-item key="appFuncManage" :title="'APP功能列表'"><router-link :to="'/func/AppFuncList'">APP功能列表</router-link></a-menu-item>
          </a-sub-menu>
          <a-sub-menu key="commonSetting">
            <span slot="title"><a-icon type="setting" /><span>公共配置</span></span>
            <a-menu-item key="dictionary" :title="'字典管理'"><router-link :to="'/common-setting/dictionary'">字典管理</router-link></a-menu-item>
            <a-menu-item key="docTpl" :title="'文档模板'"><router-link :to="'/common-setting/docTpl'">文档模板</router-link></a-menu-item>
            <a-menu-item key="preferences" :title="'首选设置项'"><router-link :to="'/common-setting/settingItem'">首选设置项</router-link></a-menu-item>
          </a-sub-menu>
        </a-menu>
      </div>
      <div style="width: 100%;">
        <a-layout style="padding: 8px 8px 8px;height: 100%;">
          <a-layout-content class="layout-content" :style="{ background: '#fff', padding: '16px', margin: 0}">
            <h3>{{pageTitle}}</h3>
            <router-view></router-view>
          </a-layout-content>
        </a-layout>
      </div>
    </a-layout>
  </a-layout>
</template>

<script>
import AuthService from "@/service/AuthService";
export default {
  name: "CommonLayout",
  data(){
    return {
      menuCollapsed: false,
      pageTitle: '欢迎页',
      userName:''
    };
  },
  created(){
    this.userName=sessionStorage.getItem('userName')
    console.log(this.userName,"this.userName")
  },
  methods: {
    changeMenuCollapsed(){
      this.menuCollapsed = !this.menuCollapsed;
    },
    logout(){
      let _this = this;
      this.$confirm({
        title: '确定退出本系统吗？',
        content: '点击确定退出',
        cancelText: "取消",
        okText: "确定",
        onOk() {
          AuthService.logout().then(()=>{
            localStorage.removeItem("Authorization");
            sessionStorage.clear()
            // sessionStorage.setItem("userName",'')
            // sessionStorage.setItem('is_login', false);
            _this.$router.push({path: '/login'})
          }).catch(()=>{
            _this.$router.push({path: '/login'})
          });
        },
        onCancel() {},
      });
    },
    //菜单点击
    menuClick(item){
      this.pageTitle = item.item.title;
    },
   
  }
}
</script>

<style scoped lang="less">
@import "../theme";

#main-layout{
  width: 100%;
  height: 100%;
}

.header {
  display: flex;
  flex-direction: row;

  .logo {
    width: 120px;
    height: 50px;
    margin: 4px 30px 4px 0;
    float: left;
    padding: 0;

    img {
      margin-left: 24px;
      line-height: 0;
      height: 40px;
    }
  }

  .nav {
    flex: 1;
  }

  .user-control {
    width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;

  }
}
.main-sidebar {
  max-width: 280px;
  height: 100%;
  background-color: @menu-dark-bg;

  .main-sidebar-menu{
    border-right: 0;
  }
}

.collapseButton{
  margin-bottom: 4px;
  margin-left: 4px;
}


.layout-content{
  min-height: calc(100% - 8px);
  height: 100%;
}

.ant-dropdown-link .anticon-down{
  color: #42b983;
}
</style>
